import styled from 'styled-components';
import {
  iconStyling,
  sectionButtonStyling,
} from '../../../commonStyles/accordionSection';
import { buttonResetStyleIncludingFocus } from '../../../commonStyles/buttonReset';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Icon from '../../Icon';

export const SectionButton = styled.button`
  ${buttonResetStyleIncludingFocus}
  ${sectionButtonStyling}
`;

export const InnerSection = styled.div`
  margin-top: ${spacing(2)};
  padding-top: ${spacing(2)};
  width: 100%;
  border-top: 2px solid ${colors.neutral06};

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(3)};
    padding-top: ${spacing(3)};
  `}
`;

export const Title = styled.h3`
  ${fonts.paragraphLarge};
  margin: 0;
`;

export const StyledIcon = styled(Icon)`
  ${iconStyling}
`;
